module.exports = __webpack_public_path__ + "media/assets/images/icons/resource-generic/file-master-2d0d8e7f3bf815034f73492cf071f191.png";